<script setup>
import { defineProps, ref, watch, defineEmits } from 'vue';
import { computed } from 'vue';
import { useStore } from 'vuex';
import CreateResult from '@/views/record/studentDetail/features/plan/CreateResult.vue';
import { useRoute, useRouter } from 'vue-router';
import { $api } from '@/services';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import DeleteForm from '@/views/formEvaluation/DeleteForm.vue';
import ConfirmSend from '@/views/planPreview/ConfirmSend.vue';
import ResultModal from '@/views/record/studentDetail/features/plan/ResultModal.vue';
import LoadingDowloadPDF from '@/views/plansDetail/features/reportTarget/loadingDowloadPDF/loadingDowloadPDF.vue';
import ChangeAssementName from '@/views/record/studentDetail/features/result/ChangeAssementName.vue';
import Multiselect from '@suadelabs/vue3-multiselect';
import { _ROUTER_NAME } from '@/enums/RouterName';

const emit = defineEmits(['closeChangeName']);
const store = useStore();
const isShow = ref(false);
const route = useRoute();
const router = useRouter();
const enableAiButton = computed(() => store.state.profile.enable_ai_button);
const skillsWithAge = ref([]);
const skills = ref([]);
const series = ref([]);
const result = ref([]);
const radarData = ref([]);
const categories = ref([]);
const is_viewed_by_parent = ref(false);
const staffs = ref([]);
const alertShow = ref(true);
const radarChartOptions = ref({
	chart: {
		id: 'radarChart',
		type: 'radar',
	},
	title: {
		show: false,
	},
	stroke: {
		width: 0,
	},
	fill: {
		opacity: 0.2,
		colors: ['#65A30D'],
	},
	markers: {
		size: 5,
		hover: {
			size: 10,
		},
		colors: ['#65A30D'],
	},
	dataLabels: {
		enabled: true,
		formatter: function (val) {
			return val + '%';
		},
		style: {
			fontFamily: 'Gilrory',
			fontSize: '20px',
			fontWeight: 'bold',
			colors: ['#344256'],
		},
		background: {
			enabled: false,
		},
	},
	yaxis: {
		show: false,
		logBase: 100,
		tickAmount: 10,
		min: 0,
		max: 100,
		labels: {
			show: false,
		},
	},
	xaxis: {
		categories: [],
		labels: {
			show: true,
			style: {
				fontFamily: 'Gilrory',
				fontSize: '14px',
				fontWeight: 600,
				colors: Array(1000).fill('#344256'),
			},
			formatter: function (val, index) {
				return index?.dataPointIndex + 1;
			},
		},
	},
	tooltip: {
		x: {
			show: true,
			formatter: function (val, object) {
				return `${object?.dataPointIndex + 1}: ${val}`;
			},
			title: {
				formatter: (seriesName) => seriesName,
			},
		},
		y: {
			show: true,
			formatter: function (val) {
				return val + '%';
			},
			title: {
				title: {
					formatter: (seriesName) => seriesName + ':',
				},
			},
		},
	},
});
const props = defineProps({
	formData: {
		type: Object,
		required: true,
	},
});
watch(
	() => props.formData,
	(newVal) => {
		note.value = newVal.note;
		recommend.value = newVal.recomended_for_parent;
		assessment.value = newVal.assessment_document?.data;
		staffs.value = newVal.assessment_document?.staffs;
		is_viewed_by_parent.value =
			newVal.assessment_document?.is_viewed_by_parent;
		conclusion.value =
			newVal.student_and_assessment_conclusion?.assessment_conclusions;
		developmentAges.value =
			newVal.assessment_document?.data.development_ages;
		prescription.value = newVal.assessment_document?.data.prescription;
		useAi.value = newVal.assessment_document?.data?.used_ai;
		skills.value = newVal.skills.map((item) => {
			const match = newVal?.skill_notes_and_ages.find(
				(i) => i.id === item?.skill?.id
			);
			return { ...item, ...match };
		});
		let a = [];
		let count = 0;
		result.value = newVal.stats?.result;
		result.value.forEach((item) => {
			if (
				item.result === 'Từ chối' ||
				item.result === 'Không có cơ hội' ||
				item.result === 'Không hợp tác'
			) {
				count += item.count;
			} else {
				a.push(item);
			}
		});
		series.value = a.map((item) => {
			return item.count;
		});
		if (newVal.skills.length) {
			radarData.value = [
				{
					name: 'Kết quả',
					data: newVal.skills.map((skill) => {
						return skill?.skill?.complete_percent;
					}),
				},
			];
			radarChartOptions.value.xaxis.categories = newVal.skills.map(
				(skill) => {
					return skill?.skill?.name;
				}
			);
			categories.value = newVal.skills.map((skill) => {
				return skill?.skill?.name;
			});
		}
	},
	{ deep: true }
);
const modalIsOpen = ref(false);
const useAi = ref(false);
const type = ref('');
const openMenu = ref(false);
const studentAge = computed(() => {
	return props.formData.student_and_assessment_conclusion.student.age;
});
const resultData = ref(null);
const create = ref(false);
const chartOptions = ref({
	dataLabels: {
		enabled: false,
	},
	colors: ['#7AD2C6', '#93BF56', '#F8BB54', '#F47C7C', '#E5E7EB'],
	labels: [
		'Đạt 80 - 100%',
		'Đạt 55 - 75%',
		'Đạt 30 - 50%',
		'Đạt 5 - 25%',
		'X',
	],
	legend: {
		show: false,
	},
	tooltip: {
		fillSeriesColor: true,
		y: {
			formatter: function (value) {
				return value + ' mục tiêu';
			},
		},
	},
	stroke: {
		lineCap: 'round',
	},
});
function openCreate() {
	type.value = 'create';
	isShow.value = true;
}
function openSend(val) {
	openMenu.value = false;
	create.value = val;
	type.value = 'preview';
	isShow.value = true;
}
function openModal(result) {
	resultData.value = result;
	isShow.value = false;
	type.value = 'send';
	if (create.value) modalIsOpen.value = true;
	else sendReport();
}
const unitType = ref(['tháng tuổi', 'tuổi']);
watch(
	skills,
	(value) => {
		value.forEach((v) => {
			if (v.age && !v.unit) {
				v.unit = 'tháng tuổi';
			}
		});
		skillsWithAge.value = value.filter((i) => i.age);
	},
	{ deep: true }
);
const editGoal = ref(false);
const goalIndex = ref(null);
function edit(data) {
	goalIndex.value = data;
	editGoal.value = true;
}
function save() {
	goalIndex.value = null;
	editGoal.value = false;
}
const editMode = ref(false);
const note = ref('');
const recommend = ref('');
const assessment = ref(null);
const conclusion = ref([]);
const developmentAges = ref([]);
const prescription = ref([]);
function submit(data) {
	type.value = '';
	isShow.value = false;
	skills.value = data.skills.map((item) => {
		const match = data?.skill_notes_and_ages.find(
			(i) => i.id === item?.skill?.id
		);
		return { ...item, ...match };
	});
	useAi.value = data.assessment_document?.data?.used_ai;
	note.value = data.note;
	recommend.value = data.recomended_for_parent;
	assessment.value = data.assessment_document?.data;
	staffs.value = data.assessment_document?.staffs;
	conclusion.value = data.student_and_assessment_conclusion;
	developmentAges.value = data.assessment_document?.data.development_ages;
	prescription.value = data.assessment_document?.data.prescription;
}

function formatValue(value) {
	if (value < 72) {
		return value + 'th';
	} else {
		const years = Math.floor(value / 12);
		return years + 'T';
	}
}

const formattedValues = computed(() => {
	let range = getAge(studentAge.value) || 15;
	const unique = new Set();
	const result = [];
	for (let i = 1; i <= range; i++) {
		const value = i * 6 - 6;
		const formatted = formatValue(value);
		if (!unique.has(formatted)) {
			unique.add(formatted);
			result.push(formatted);
		}
	}
	return result;
});

function getAgeWidth(ageInMonths) {
	const basePx = 64;
	if (ageInMonths <= 72) {
		return (ageInMonths / 6) * basePx + 'px';
	} else {
		const first72 = (72 / 6) * basePx;
		const extraMonths = ageInMonths - 72;
		const extraYears = extraMonths / 12;
		return first72 + extraYears * basePx + 'px';
	}
}

function parseAgeToMonths(ageString) {
	const yearMatch = ageString.match(/(\d+)\s*tuổi/);
	const monthMatch = ageString.match(/(\d+)\s*tháng/);
	const years = yearMatch ? parseInt(yearMatch[1]) : 0;
	const months = monthMatch ? parseInt(monthMatch[1]) : 0;
	return years * 12 + months;
}

function getAge(data) {
	if (data) {
		data = data.toLowerCase().trim();
		if (data.includes('tuổi') && data.includes('tháng')) {
			const ageMatch = data.match(/(\d+)\s*tuổi\s*(\d*)\s*tháng?/);
			if (ageMatch) {
				const years = parseInt(ageMatch[1], 10);
				const months = parseInt(ageMatch[2] || '0', 10);
				return years * 2 + (months >= 6 ? 1 : 0);
			}
		} else if (data.includes('tuổi')) {
			const match = data.match(/(\d+)\s*tuổi/);
			if (match) {
				const years = parseInt(match[1], 10);
				return years * 2;
			}
		}
	} else return 15;
}
function deleteModal() {
	openMenu.value = false;
	modalIsOpen.value = true;
	type.value = 'delete';
}
function changeName() {
	openMenu.value = false;
	modalIsOpen.value = true;
	type.value = 'change';
}
function closeChangeName() {
	modalIsOpen.value = false;
	type.value = '';
	emit('closeChangeName');
}
function closeModal() {
	modalIsOpen.value = false;
	type.value = '';
}

const duplicateForm = async () => {
	try {
		openMenu.value = false;
		await $api.form.duplicateStudentForm(route.params.id, {
			student_assessment_form_id: route.query.formId,
		});
		await store.dispatch('setAlertMessage', {
			message: 'Nhân bản thành công',
			type: 'success',
		});
	} catch (err) {
		await store.dispatch('setAlertMessage', {
			message:
				err?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
};
const deleteStudentForm = async () => {
	try {
		await $api.form.deleteStudentForm(route.params.id, route.query.formId);
		await store.dispatch('setAlertMessage', {
			message: 'Xoá biểu mẫu thành công',
			type: 'success',
		});
		router.push(`/record/student/${route.params.id}/result`);
	} catch (err) {
		await store.dispatch('setAlertMessage', {
			message:
				err?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
};
const download = ref(false);
const sendReport = async () => {
	try {
		modalIsOpen.value = false;
		await $api.form.sendForm(
			Number(route.params.id),
			Number(route.query.formId),
			{
				student_assessment_form: {
					send: create.value,
					prescription: resultData.value.prescription?.filter(
						(item) => !!item
					),
					development_age: resultData.value.development_ages?.filter(
						(item) => !!item
					),
					assessment_conclusion:
						resultData.value.assessment_conclusions?.filter(
							(item) => !!item
						),
					note: resultData.value.note,
					assessment_date: resultData.value.assessment_date,
					name: resultData.value.name,
					used_ai: useAi.value,
					recomended_for_parent: recommend.value,
					skill_notes_and_ages: skills.value.map(
						({ goals, skill, ...rest }) => rest
					),
				},
			}
		);

		await store.dispatch('setAlertMessage', {
			message: create.value
				? 'Gửi tới phụ huynh thành công'
				: 'Lưu bản nháp thành công',
		});
		if (download.value) {
			downloadPDF();
		} else router.push(`/record/student/${route.params.id}/result`);
	} catch (e) {
		store.dispatch('setAlertMessage', {
			message:
				e?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
};

async function downloadPDF() {
	const url =
		process.env.VUE_APP_PDF_URL +
		'record/student/' +
		route.params.id +
		'/result/' +
		route.params.result_id +
		'?token=' +
		localStorage.getItem('tk') +
		'&subdomain=' +
		localStorage.getItem('sub-domain') +
		'&student_form=true&formId=' +
		route.query.formId;
	window.open(url, '_blank');
	// try {
	// 	openMenu.value = false;
	// 	type.value = 'loading';
	// 	modalIsOpen.value = true;
	// 	const params = {
	// 		url: url,
	// 		format: 'a2',
	// 		id_render: 'form_pdf',
	// 	};
	// 	const response = await fetch(
	// 		'https://g4ridpplxi.execute-api.ap-southeast-1.amazonaws.com/',
	// 		{
	// 			method: 'POST',
	// 			body: JSON.stringify(params),
	// 			headers: {
	// 				Accept: 'application/json',
	// 				'Content-Type': 'application/json',
	// 			},
	// 		}
	// 	);
	// 	if (!response.ok) {
	// 		window.location.href = url + '&is_print=true';
	// 		closeModal();
	// 		return;
	// 	}
	// 	const data = await response.json();
	// 	if (data.data) {
	// 		closeModal();
	// 		const linkSource = `data:application/pdf;base64, ${data.data}`;
	// 		const link = document.createElement('a');
	// 		const fileName = 'BaoCaoDanhGiaPhatTrien.pdf';
	// 		link.href = linkSource;
	// 		link.download = fileName;
	// 		link.click();
	// 	}
	// } catch (e) {
	// 	window.location.href = url + '&is_print=true';
	// 	closeModal();
	// 	console.log(e);
	// }
}

function saveAndDownload() {
	if (useAi.value) {
		download.value = true;
		openSend(false);
	} else downloadPDF();
}
</script>
<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<create-form
			v-if="type === 'create' || type === 'edit'"
			@close="closeModal"
			:type="type"
			:form="form ? form : null"
			:open="modalIsOpen"
		/>
		<delete-form
			v-if="type === 'delete'"
			@submit="deleteStudentForm"
			@close="closeModal"
			:editText="true"
		/>
		<confirm-send
			v-if="type === 'send'"
			@close="closeModal"
			@submit="sendReport"
		/>
		<LoadingDowloadPDF
			v-if="type === 'loading'"
			:text="'Đang tải file PDF báo cáo đánh giá phát triển'"
		/>
		<change-assement-name
			v-if="type === 'change'"
			@close="closeChangeName"
			:assementName="props.formData?.assessment_document?.data?.name"
		/>
	</DaModalFrame>
	<div :class="isShow ? 'side-over--active' : ''">
		<div
			v-if="isShow"
			class="fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30"
			@click="isShow = false"
		></div>

		<CreateResult
			v-if="type === 'create'"
			v-model:refresh="isShow"
			@close="isShow = false"
			@submit="submit"
			:student="props.formData?.student_and_assessment_conclusion"
			:isShow="isShow"
			@to-preview="openModal"
		/>
		<ResultModal
			v-if="type === 'preview'"
			v-model:refresh="isShow"
			@close="isShow = false"
			:developmentAges="developmentAges"
			:assessmentConclusions="
				conclusion ||
				props.formData?.student_and_assessment_conclusion
					?.assessment_conclusions
			"
			:prescriptions="prescription"
			:note="note"
			:formName="assessment?.name"
			:create="create"
			:date="assessment?.inserted_at"
			@to-preview="openModal"
		/>
	</div>
	<div>
		<div v-if="props.formData.data?.state !== 'completed'">
			<div class="__report-lesson__header">
				<div class="flex flex-nowrap justify-between items-center mb-2">
					<div
						class="__record__title text-neutral-700 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl gap-4"
					>
						<svg
							class="cursor-pointer"
							width="28"
							height="28"
							viewBox="0 0 28 28"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							@click="
								$router.push(
									`/record/student/${route.params.id}/result`
								)
							"
						>
							<path
								d="M17.5 7L10.5 14L17.5 21"
								stroke="#94A3B8"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
						<img
							src="@/assets/images/icons/form-evaluation.png"
							alt=""
						/>
						<div>
							{{
								props.formData?.assessment_document?.data?.name
							}}
						</div>
					</div>
					<div class="items-center flex gap-3">
						<button
							class="button-p btn--ghost w-fit px-4"
							type="button"
							@click.stop="
								$router.push(
									`/record/student/${route.params.id}/form-evaluation/${route.query.formId}/form-create`
								)
							"
						>
							Chỉnh sửa
						</button>
						<div
							class="w-full flex justify-center items-center relative"
						>
							<img
								@click.stop="openMenu = !openMenu"
								class="w-6 h-6 cursor-pointer"
								src="@/assets/images/icons/three-dots.png"
								alt=""
							/>
							<div
								v-if="openMenu"
								class="absolute menu-action py-1 z-10 bot-190"
							>
								<div
									@click.stop="duplicateForm"
									class="flex items-center gap-3 px-4 py-2 hover:bg-orange-50 cursor-pointer"
								>
									<img
										class="w-4 h-4"
										src="@/assets/images/icons/copy.png"
										alt=""
									/>
									<div class="text-neutral-700">Nhân bản</div>
								</div>
								<div
									@click.stop="changeName"
									class="flex items-center gap-3 px-4 py-2 hover:bg-orange-50 cursor-pointer"
								>
									<img
										class="w-4 h-4"
										src="@/assets/images/icons/pen.png"
										alt=""
									/>
									<div class="text-neutral-700">Đổi tên</div>
								</div>
								<div
									@click.stop="downloadPDF"
									class="flex items-center gap-3 px-4 py-2 hover:bg-orange-50 cursor-pointer"
								>
									<img
										class="w-4 h-4"
										src="@/assets/images/icons/cloud-download-fill.png"
										alt=""
									/>
									<div class="text-neutral-700">
										Tải file .pdf
									</div>
								</div>
								<div
									@click.stop="deleteModal"
									class="flex items-center gap-3 px-4 py-2 hover:bg-orange-50 cursor-pointer"
								>
									<img
										class="w-4 h-4"
										src="@/assets/images/icons/trash.png"
										alt=""
									/>
									<div class="text-neutral-700">Xoá</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="text-green-500 text-xs font-semibold">
					TẠO BỞI
					<span class="text-blue-600 text-sm">{{
						props.formData?.assessment_document?.data
							?.created_by_staff?.full_name
					}}</span>
					| LÚC
					{{
						$filters.formatDateTime(
							props.formData.assessment_document?.data
								?.inserted_at
						)
					}}
				</div>
			</div>
			<div class="my-10" v-if="alertShow">
				<div
					class="bg-yellow-50 border-l-4 border-yellow-600 p-4 rounded-md"
				>
					<div class="flex justify-between gap-4">
						<div class="flex items-center gap-4">
							<div>
								<img
									src="@/assets/images/logo/logo.svg"
									alt="luca-logo"
									height="24"
									width="35"
								/>
							</div>
							<div class="pt-1 text-neutral-600 text-sm">
								Dùng ứng dụng Luca Pro để báo cáo kết quả mục
								tiêu cho đánh giá phát triển này.
							</div>
						</div>
						<div>
							<svg
								width="12"
								height="12"
								viewBox="0 0 12 12"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								class="cursor-pointer"
								@click="alertShow = false"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
									fill="#E5A42B"
								/>
							</svg>
						</div>
					</div>
				</div>
			</div>
			<div class="grid grid-cols-1 md:grid-cols-2 gap-4 my-6">
				<div
					class="flex items-center justify-between bg-white py-4 px-6 rounded-lg shadow"
				>
					<div class="flex items-center gap-2">
						<img
							alt=""
							height="32"
							src="@/assets/images/icons/abc.png"
							style="height: 32px"
							width="32"
						/>
						<div class="text-neutral-500 text-sm">Lĩnh vực</div>
					</div>
					<div class="font-bold text-4xl text-neutral-600">
						{{ Number(props.formData?.stats?.skill_count || 0) }}
					</div>
				</div>
				<div
					class="flex items-center justify-between bg-white py-4 px-6 rounded-lg shadow"
				>
					<div class="flex items-center gap-2">
						<img
							alt=""
							height="32"
							src="@/assets/images/icons/light.png"
							style="height: 32px"
							width="32"
						/>
						<div class="text-neutral-500 text-sm">Mục tiêu</div>
					</div>
					<div class="font-bold text-4xl text-neutral-600">
						{{ Number(props.formData?.stats?.goal_count || 0) }}
					</div>
				</div>
			</div>
			<div
				v-for="(s, index) in props.formData?.skills"
				:key="index"
				class="mb-4"
			>
				<div class="flex items-center justify-between mb-4">
					<div class="flex items-center">
						<div class="font-semibold text-neutral-700">
							{{ index + 1 }}. {{ s.skill?.name }} ({{
								s.goals.length
							}})
						</div>
					</div>
				</div>
				<div
					class="shadow-sm sm:rounded-2xl overflow-hidden md-down:hidden"
				>
					<div class="__record__table overflow-x-auto scroll-bar">
						<div
							class="overflow-hidden sm:rounded-t-2xl w-fit min-w-full"
						>
							<table class="min-w-full divide-y text-neutral-200">
								<thead class="bg-neutral-100 h-16">
									<tr>
										<th
											class="px-4 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap w-16"
											scope="col"
										>
											STT
										</th>
										<th
											class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
											scope="col"
										>
											Nội dung
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(i, gIndex) in s.goals"
										:key="gIndex"
										:class="[
											gIndex % 2 === 0
												? 'bg-white'
												: 'bg-neutral-50',
										]"
										class="text-neutral-700 hover:bg-orange-50"
									>
										<td
											class="p-4 whitespace-nowrap text-neutral-700 text-center"
										>
											{{ gIndex + 1 }}
										</td>
										<td
											class="px-6 py-4 whitespace-nowrap text-neutral-700"
										>
											<div
												class="flex items-center gap-2"
											>
												<div
													class="whitespace-normal"
													v-html="
														i.name || i.goal_name
													"
												></div>
											</div>
											<div
												class="flex gap-2 flex-wrap"
												style="max-width: 360px"
											>
												<template
													v-if="i?.assistance_levels"
												>
													<div
														v-for="ass in i?.assistance_levels"
														:key="ass"
														class="flex gap-2"
													>
														<div
															class="mt-1 py-0.5 px-2.5 rounded-full bg-pink-100 whitespace-nowrap text-neutral-700 h-fit w-fit font-semibold shadow-input"
															style="
																font-size: 10px;
															"
														>
															{{ ass }}
														</div>
													</div>
												</template>
												<div
													class="mt-1 py-0.5 px-2.5 rounded-full bg-yellow-tag text-neutral-700 h-fit w-fit font-semibold shadow-input whitespace-nowrap"
													style="font-size: 10px"
													v-if="i?.age"
												>
													{{ i?.age }}
												</div>
											</div>

											<div
												v-if="
													i.parent?.sub_goal_count > 0
												"
												class="goal-block flex gap-3 mt-2"
											>
												<img
													class="w-3 h-3 mt-1"
													src="@/assets/images/icons/goal-arrow.png"
													alt=""
												/>
												<div>
													<div
														class="text-neutral-700 whitespace-normal"
														v-html="i.parent?.name"
													></div>
													<div
														class="text-neutral-400 text-xs font-semibold"
													>
														{{
															i.parent
																?.sub_goal_count
														}}
														MỤC TIÊU
													</div>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="relative mb-6" v-if="useAi">
				<div
					aria-hidden="true"
					class="absolute inset-0 flex items-center"
				>
					<div class="w-full border-t border-neutral-300" />
				</div>
				<div class="relative flex items-center justify-center">
					<div
						class="flex items-center gap-1 px-5 py-3 bg-white cursor-pointer"
						style="border: 1px solid #f1f5f9"
						@click="saveAndDownload"
					>
						<img
							src="@/assets/images/icons/cloud-download-fill.png"
							alt=""
						/>
						<div class="text-neutral-600 font-semibold">
							Tải file .pdf
						</div>
					</div>
				</div>
			</div>
			<div
				class="bg-white shadow-sm rounded-2xl overflow-hidden pb-4 mt-6"
			>
				<div
					class="bg-orange-50 p-4 px-6 flex md:items-center justify-between text-gray-700 md-down:flex-col"
				>
					<div class="font-semibold text-lg">
						Báo cáo
						<span class="text-green-500">{{
							assessment?.name
						}}</span>
					</div>
					<button
						class="button-p text-center whitespace-nowrap w-max"
						type="button"
						@click="openSend(true)"
						v-if="assessment?.sent_at === null && useAi"
					>
						Gửi tới phụ huynh
					</button>
					<div
						v-if="is_viewed_by_parent"
						class="flex items-center justify-end gap-2"
					>
						Phụ huynh xác nhận đã xem
						<svg
							fill="none"
							height="20"
							viewBox="0 0 20 20"
							width="20"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clip-path="url(#clip0_29861_3992)">
								<path
									d="M9.26745 5.21165H2.62886C1.64009 5.21165 0.833008 6.0187 0.833008 7.0075V14.7761C0.833008 15.7648 1.64006 16.5719 2.62886 16.5719H5.05019L5.05033 19.2959C5.05033 19.9013 5.75664 20.2241 6.20055 19.8205L10.0344 16.5517H13.3235C14.3122 16.5517 15.1193 15.7446 15.1193 14.7558L15.1192 11.0834C11.8907 11.0834 9.26752 8.44011 9.26752 5.21158L9.26745 5.21165Z"
									fill="#339588"
								/>
								<path
									d="M15.1393 0.833008C12.7179 0.833008 10.7606 2.79028 10.7606 5.21165C10.7606 7.63302 12.7179 9.5903 15.1393 9.5903C17.5606 9.5903 19.5179 7.63302 19.5179 5.21165C19.5179 2.79028 17.5606 0.833008 15.1393 0.833008ZM17.2781 4.60631L15.0989 6.78554C14.9778 6.90659 14.7963 6.98738 14.6146 6.98738C14.433 6.98738 14.2514 6.90673 14.1303 6.78554L12.98 5.63532C12.7177 5.37296 12.7177 4.92901 12.98 4.66681C13.2424 4.40445 13.6863 4.40445 13.9485 4.66681L14.5943 5.31258L16.2892 3.61766C16.5516 3.3553 16.9955 3.3553 17.2578 3.61766C17.5606 3.90014 17.5606 4.34407 17.2782 4.60631H17.2781Z"
									fill="#339588"
								/>
								<path
									d="M8.78697 5.71165C9.02947 8.81816 11.5111 11.3196 14.6192 11.5638L14.6193 14.7558C14.6193 14.7558 14.6193 14.7558 14.6193 14.7558C14.6193 15.4685 14.0361 16.0517 13.3235 16.0517H10.0344H9.85017L9.70999 16.1712L5.87615 19.44L5.87008 19.4452L5.86417 19.4506C5.75578 19.5491 5.55033 19.4867 5.55033 19.2959L5.55019 16.5719L5.55017 16.0719H5.05019H2.62886C1.91621 16.0719 1.33301 15.4887 1.33301 14.7761V7.0075C1.33301 6.29485 1.91623 5.71165 2.62886 5.71165H8.78697ZM15.4524 7.1391L17.6251 4.96641C18.1223 4.4978 18.1008 3.72652 17.6051 3.25789C17.1468 2.8064 16.3911 2.80865 15.9357 3.2641L14.5943 4.60547L14.3022 4.31336C14.3022 4.31332 14.3021 4.31329 14.3021 4.31325C13.8446 3.85558 13.0841 3.85572 12.6266 4.31315C12.1688 4.7707 12.1689 5.53131 12.6265 5.98887L13.7767 7.13908C13.7767 7.13909 13.7767 7.13909 13.7767 7.1391C13.9873 7.34967 14.2943 7.48738 14.6146 7.48738C14.9351 7.48738 15.2421 7.34942 15.4524 7.1391ZM11.2606 5.21165C11.2606 3.06643 12.9941 1.33301 15.1393 1.33301C17.2845 1.33301 19.0179 3.06642 19.0179 5.21165C19.0179 7.35688 17.2845 9.0903 15.1393 9.0903C12.994 9.0903 11.2606 7.35688 11.2606 5.21165Z"
									stroke="#339588"
								/>
							</g>
							<defs>
								<clipPath id="clip0_29861_3992">
									<rect fill="white" height="20" width="20" />
								</clipPath>
							</defs>
						</svg>
					</div>
				</div>
				<div class="flex justify-between p-6 pb-1 flex-wrap">
					<div class="flex-col gap-4">
						<div>
							Ngày thực hiện:
							{{ $filters.formatDate(assessment?.inserted_at) }}
						</div>
					</div>
					<div>
						<div
							class="flex items-center flex-wrap gap-1"
							v-if="staffs.length > 0"
						>
							<div>Thực hiện bởi</div>
							<div class="font-semibold text-blue-700">
								{{ staffs.map((item) => item.name).join(', ') }}
							</div>
						</div>
						<div
							class="text-neutral-700"
							v-if="assessment?.sent_at"
						>
							<span class="text-blue-700">{{
								assessment?.sent_by_staff?.name
							}}</span>
							đã gửi tới PH
							{{ $filters.formatDate(assessment?.sent_at) }}
						</div>
					</div>
				</div>
			</div>
			<div
				class="mt-6 bg-white rounded-2xl shadow-sm overflow-hidden relative"
			>
				<div
					class="__data__header p-6 flex items-center justify-between"
				>
					<div class="flex items-center justify-between w-full">
						<div class="text-neutral-600 font-semibold">
							{{ assessment?.name }}
						</div>
						<div class="flex items-center gap-4">
							<img
								v-if="assessment?.sent_at"
								@click="openSend(false)"
								class="w-5 h-5 cursor-pointer"
								src="@/assets/images/icons/edit-fill.png"
								alt=""
							/>
							<div
								v-if="
									$route.name !==
									_ROUTER_NAME.RECORD_STUDENT_DETAIL_RESULT_DETAIL_PDF
								"
								class="hover:text-yellow-700 text-yellow-600 cursor-pointer"
								@click="deleteModal"
							>
								<svg
									fill="none"
									height="20"
									viewBox="0 0 20 20"
									width="20"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										clip-rule="evenodd"
										d="M3.125 1.25C2.43464 1.25 1.875 1.80964 1.875 2.5V3.75C1.875 4.44036 2.43464 5 3.125 5H3.75V16.25C3.75 17.6307 4.86929 18.75 6.25 18.75H13.75C15.1307 18.75 16.25 17.6307 16.25 16.25V5H16.875C17.5654 5 18.125 4.44036 18.125 3.75V2.5C18.125 1.80964 17.5654 1.25 16.875 1.25H12.5C12.5 0.559644 11.9404 0 11.25 0H8.75C8.05964 0 7.5 0.559644 7.5 1.25H3.125ZM6.875 6.25C7.22018 6.25 7.5 6.52982 7.5 6.875V15.625C7.5 15.9702 7.22018 16.25 6.875 16.25C6.52982 16.25 6.25 15.9702 6.25 15.625L6.25 6.875C6.25 6.52982 6.52982 6.25 6.875 6.25ZM10 6.25C10.3452 6.25 10.625 6.52982 10.625 6.875V15.625C10.625 15.9702 10.3452 16.25 10 16.25C9.65482 16.25 9.375 15.9702 9.375 15.625V6.875C9.375 6.52982 9.65482 6.25 10 6.25ZM13.75 6.875C13.75 6.52982 13.4702 6.25 13.125 6.25C12.7798 6.25 12.5 6.52982 12.5 6.875V15.625C12.5 15.9702 12.7798 16.25 13.125 16.25C13.4702 16.25 13.75 15.9702 13.75 15.625V6.875Z"
										fill="currentColor"
										fill-rule="evenodd"
									/>
								</svg>
							</div>
						</div>
					</div>
				</div>
				<div class="__data__content text-neutral-800">
					<div class="flex items-center px-6 py-4 bg-neutral-50">
						<div class="w-1/4 text-neutral-500">Tuổi thực</div>
						<div>{{ assessment.age }}</div>
					</div>
					<div class="flex items-center px-6 py-4">
						<div class="w-1/4 text-neutral-500">
							Tuổi phát triển
						</div>
						<div>
							<div
								v-for="(
									item, index
								) in assessment?.development_ages"
								:key="index"
							>
								{{ item }}
							</div>
						</div>
					</div>
					<div class="flex items-center px-6 py-4 bg-neutral-50">
						<div class="w-1/4 text-neutral-500">Kết luận</div>
						<div
							v-if="assessment.assessment_conclusions.length > 0"
						>
							<div
								v-for="(
									item, index
								) in assessment.assessment_conclusions"
								:key="index"
							>
								{{ item }}
							</div>
						</div>
						<div v-else>
							<div
								v-for="(item, index) in useAi
									? conclusion
									: conclusion?.assessment_conclusions"
								:key="index"
							>
								{{ item.assessment_conclusion }}
							</div>
						</div>
					</div>
					<div class="flex items-center px-6 py-4">
						<div class="w-1/4 text-neutral-500">Đơn thuốc</div>
						<div>
							<div
								v-for="(
									item, index
								) in assessment?.prescription"
								:key="index"
							>
								{{ item }}
							</div>
						</div>
					</div>
					<div class="flex items-center px-6 py-4 bg-neutral-50">
						<div class="w-1/4 text-neutral-500">
							Chỉnh sửa gần nhất
						</div>
						<div class="flex items-center">
							<div v-if="assessment?.edited_by_staff">
								<span class="font-semibold text-blue-700">{{
									assessment?.edited_by_staff?.name
								}}</span>
								<span class="mx-2">-</span>
							</div>
							{{
								assessment.updated_at
									? $filters.formatDate(
											assessment?.updated_at
									  )
									: ''
							}}
						</div>
					</div>
				</div>
			</div>
			<div class="mt-6" v-if="note || recommend">
				<div class="bg-white shadow-sm rounded-2xl">
					<div
						class="w-full flex items-center justify-between p-6"
						:class="{ 'border-bot': note || recommend }"
					>
						<div class="font-semibold text-neutral-600">
							Nhận xét chung về quá trình can thiệp của trẻ
						</div>
						<div v-if="!assessment?.sent_at">
							<div v-if="!editMode">
								<div
									class="flex items-center gap-2 cursor-pointer"
									@click="editMode = true"
								>
									<img
										class="w-4 h-4"
										src="@/assets/images/icons/edit-fill.png"
										alt=""
									/>
									<div class="text-yellow-700 font-semibold">
										Chỉnh sửa
									</div>
								</div>
							</div>
							<div v-else>
								<button
									class="flex items-center gap-2 luca-button"
									@click="editMode = false"
								>
									<img
										class="w-4 h-4"
										src="@/assets/images/icons/save.png"
										alt=""
									/>
									<div>Lưu chỉnh sửa</div>
								</button>
							</div>
						</div>
					</div>
					<div class="px-6 pb-6">
						<div class="mb-4" v-if="note">
							<div
								class="text-gray-400 font-semibold mb-1 uppercase text-xs"
							>
								NHẬN XÉT
							</div>
							<textarea v-if="editMode" rows="6" v-model="note">
							</textarea>
							<div
								v-else
								class="text-gray-700"
								v-html="note.replaceAll('\n', '<br />')"
							></div>
						</div>
						<div v-if="recommend">
							<div
								class="text-gray-400 font-semibold mb-1 uppercase text-xs"
							>
								Gợi ý cho phụ huynh
							</div>
							<textarea
								v-if="editMode"
								rows="6"
								v-model="recommend"
							>
							</textarea>
							<div
								v-else
								class="text-gray-700"
								v-html="recommend.replaceAll('\n', '<br />')"
							></div>
						</div>
					</div>
				</div>
			</div>
			<div class="relative mt-6">
				<div
					aria-hidden="true"
					class="absolute inset-0 flex items-center"
				>
					<div class="w-full border-t border-neutral-300" />
				</div>
				<div class="relative flex items-center justify-center">
					<div
						class="px-2.5 py-1 bg-body text-neutral-600 font-semibold"
					>
						Thống kê
					</div>
				</div>
			</div>
			<div class="mt-10">
				<div class="p-6 bg-white shadow-sm rounded-2xl">
					<div class="w-full flex items-center justify-between mb-6">
						<div class="font-semibold text-neutral-600">
							Thống kê chung
						</div>
						<div
							class="flex items-center justify-between gap-2"
							v-if="
								$route.name !==
								_ROUTER_NAME.RECORD_STUDENT_DETAIL_RESULT_DETAIL_PDF
							"
						>
							<button
								v-if="enableAiButton && !assessment?.sent_at"
								class="luca-button flex items-center gap-1"
								@click="openCreate"
							>
								<div class="whitespace-nowrap">
									Tạo Đánh giá phát triển Luca AI
								</div>
								<img
									class="w-4 h-4"
									src="@/assets/images/icons/coin.png"
									alt=""
								/>
								<div>30</div>
							</button>
							<div class="relative">
								<img
									@click.stop="openMenu = !openMenu"
									class="w-6 h-6 cursor-pointer"
									src="@/assets/images/icons/three-dots.png"
									alt=""
								/>
								<div
									v-if="openMenu"
									class="absolute menu-action py-1 z-10 bot-15"
									:class="{ 'bot-20': useAi }"
								>
									<div
										v-if="!useAi"
										@click.stop="changeName"
										class="flex items-center gap-3 px-4 py-2 hover:bg-orange-50 cursor-pointer"
									>
										<img
											class="w-4 h-4"
											src="@/assets/images/icons/pen.png"
											alt=""
										/>
										<div class="text-neutral-700">
											Đổi tên
										</div>
									</div>
									<div
										v-if="!useAi"
										@click.stop="downloadPDF"
										class="flex items-center gap-3 px-4 py-2 hover:bg-orange-50 cursor-pointer"
									>
										<img
											class="w-4 h-4"
											src="@/assets/images/icons/cloud-download-fill.png"
											alt=""
										/>
										<div class="text-neutral-700">
											Tải file .pdf
										</div>
									</div>
									<div
										v-if="!useAi"
										@click.stop="deleteModal"
										class="flex items-center gap-3 px-4 py-2 hover:bg-orange-50 cursor-pointer"
									>
										<img
											class="w-4 h-4"
											src="@/assets/images/icons/trash.png"
											alt=""
										/>
										<div class="text-neutral-700">Xoá</div>
									</div>
									<div
										v-if="useAi"
										@click.stop="openSend(false)"
										class="flex items-center gap-3 px-4 py-2 hover:bg-orange-50 cursor-pointer"
									>
										<svg
											width="16"
											height="16"
											viewBox="0 0 16 16"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M9.33333 0H1.33333C0.593333 0 0 0.6 0 1.33333V10.6667C0 11.4 0.593333 12 1.33333 12H10.6667C11.4 12 12 11.4 12 10.6667V2.66667L9.33333 0ZM6 10.6667C4.89333 10.6667 4 9.77333 4 8.66667C4 7.56 4.89333 6.66667 6 6.66667C7.10667 6.66667 8 7.56 8 8.66667C8 9.77333 7.10667 10.6667 6 10.6667ZM8 4H1.33333V1.33333H8V4Z"
												fill="#94A3B8"
											/>
										</svg>
										<div class="text-neutral-700">
											Lưu bản nháp
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="flex flex-nowrap w-full md-down:flex-col">
						<div
							class="p-6 border rounded-l-lg border-neutral-200 w-full md-down:rounded-t md-down:rounded-b-none"
						>
							<div
								class="text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center"
							>
								<img
									alt=""
									class="mr-2"
									height="32"
									src="@/assets/images/icons/abc.png"
									style="height: 32px"
									width="32"
								/>
								{{
									Number(
										props.formData?.stats?.skill_count || 0
									)
								}}
							</div>
							<div class="flex flex-nowrap items-center">
								<span class="text-neutral-500 text-sm"
									>Lĩnh vực đã học
								</span>
							</div>
						</div>
						<div
							class="p-6 border-t border-b border-neutral-200 w-full md-down:border-l md-down:border-r md-down:border-b-0"
						>
							<div
								class="text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center"
							>
								<img
									alt=""
									class="mr-2"
									height="32"
									src="@/assets/images/icons/light.png"
									style="height: 32px"
									width="32"
								/>
								{{
									Number(
										props.formData?.stats?.goal_count || 0
									)
								}}
							</div>
							<div class="flex flex-nowrap items-center">
								<span class="text-neutral-500 text-sm"
									>Mục tiêu đã học
								</span>
							</div>
						</div>
					</div>
				</div>
				<div class="mt-6" v-if="skillsWithAge.length > 0">
					<div class="bg-white shadow border-sm rounded-lg">
						<div class="border-bot">
							<div
								class="text-neutral-500 font-semibold border-b p-6"
							>
								Biểu đồ mối tương quan tuổi phát triển và tuổi
								thực của trẻ qua các lĩnh vực đã học
							</div>
							<div
								class="font-semibold text-gray-700 whitespace-nowrap px-6 pt-6 mb-2"
							>
								Lĩnh vực
							</div>
							<div
								class="relative px-6 pb-6 flex items-center text-neutral-500 gap-4 overflow-x-auto"
							>
								<div class="h-full pb-9">
									<div
										:style="{
											height:
												45 * skillsWithAge.length +
												'px',
										}"
										class="flex flex-col items-start justify-between"
									>
										<div
											v-for="i in skillsWithAge"
											:key="i.id"
											class="font-semibold text-gray-400 whitespace-nowrap"
										>
											{{ i.name }}
										</div>
									</div>
								</div>
								<div
									class="w-max flex flex-nowrap pt-6 relative"
								>
									<div
										class="absolute l-0 w-full flex flex-col items-start justify-between"
										:style="{
											height:
												45 * skillsWithAge.length +
												'px',
										}"
									>
										<div
											v-for="i in skillsWithAge"
											:key="i.id"
											class="flex items-center gap-2 w-full"
										>
											<div
												:style="{
													width: getAgeWidth(
														i.unit === 'tuổi'
															? i.age * 12
															: i.age
													),
												}"
												class="percent"
											></div>
											<div
												class="text-gray-500 font-semibold text-sm"
											>
												{{
													i.unit === 'tuổi'
														? i.age * 12
														: i.age
												}}
											</div>
										</div>
									</div>
									<div
										v-for="i in formattedValues"
										:key="i"
										class="flex-1 w-16"
									>
										<div
											class="border border-t-0 border-b-0 border-l border-neutral-200"
											:class="{
												'border-r-0':
													i !==
													formattedValues.length - 1,
											}"
											:style="{
												height:
													45 * skillsWithAge.length +
													'px',
											}"
										></div>
										<div
											class="text-neutral-500 text-sm mt-8 font-semibold float-left -ml-2"
										>
											{{ i }}
										</div>
									</div>
									<div
										class="absolute text-gray-500 font-semibold whitespace-nowrap"
										:style="{
											left: getAgeWidth(
												parseAgeToMonths(studentAge)
											),
											'margin-left': '-25px',
											top: '-5px',
										}"
									>
										{{ studentAge }}
									</div>
									<div
										class="absolute student-age"
										:style="{
											left: getAgeWidth(
												parseAgeToMonths(studentAge)
											),
											height:
												45 * skillsWithAge.length +
												'px',
										}"
									></div>
								</div>
								<div
									class="flex items-end font-semibold text-gray-700 whitespace-nowrap"
									:style="{
										height:
											45 * skillsWithAge.length +
											81 +
											'px',
									}"
								>
									Tuổi phát triển
								</div>
							</div>
							<div
								class="text-gray-700 flex item-center gap-10 p-6"
							>
								<div class="flex items-center gap-2">
									<div class="r-age w-4 h-4 rounded-lg"></div>
									<div class="text-sm">Tuổi thực</div>
								</div>
								<div class="flex items-center gap-2">
									<div class="d-age w-4 h-4 rounded-lg"></div>
									<div class="text-sm">Tuổi phát triển</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="flex items-stretch gap-6 xl-down:flex-col mt-6 mb-10"
				>
					<div
						class="bg-white shadow-sm rounded-2xl overflow-hidden w-1/3 xl-down:w-full flex flex-col min-h-0 min-w-0"
					>
						<div
							class="font-semibold text-neutral-500 p-6 shrink-0"
						>
							Biểu đồ kết quả các mục tiêu
						</div>
						<div
							class="flex flex-1 flex-col min-h-0 p-6 border-t border-orange-50 items-center justify-between"
						>
							<div class="relative w-fit md-down:w-full">
								<apexchart
									:options="chartOptions"
									:series="series"
									height="220"
									type="donut"
								></apexchart>
								<div
									class="text-center absolute top-1/2 left-1/2 transform"
									style="transform: translate(-50%, -50%)"
								>
									<div
										class="text-4xl font-bold text-neutral-600"
									>
										{{ props.formData?.stats?.goal_count }}
									</div>
									<div class="text-neutral-500">Mục tiêu</div>
								</div>
							</div>
							<div
								class="flex flex-col w-full justify-center mt-4"
							>
								<div
									v-if="result[0]?.count > 0"
									class="flex flex-nowrap items-center mb-4 justify-center"
								>
									<div
										class="text-sm font-semibold text-neutral-500 w-14 blue"
									>
										{{ result[0]?.count }}
										M.T
									</div>
									<span
										class="flex items-center justify-center py-0.5 rounded-full text-sm text-white font-semibold whitespace-nowrap w-32 shadow-input"
										style="background: #2aa797"
									>
										{{ result[0]?.result }}
									</span>
								</div>
								<div
									v-if="result[1]?.count > 0"
									class="flex flex-nowrap items-center mb-4 justify-center"
								>
									<div
										class="text-sm text-neutral-500 w-14 font-semibold"
									>
										{{ result[1]?.count }}
										M.T
									</div>
									<span
										class="flex items-center justify-center py-0.5 rounded-full text-sm text-white font-semibold w-32 whitespace-nowrap shadow-input"
										style="background: #65a30d"
									>
										{{ result[1]?.result }}
									</span>
								</div>
								<div
									v-if="result[2]?.count > 0"
									class="flex flex-nowrap items-center mb-4 justify-center"
								>
									<div
										class="text-sm font-semibold text-neutral-500 w-14"
									>
										{{ result[2]?.count }}
										M.T
									</div>
									<span
										class="flex items-center justify-center py-0.5 rounded-full text-sm text-white font-semibold w-32 whitespace-nowrap shadow-input"
										style="background: #f59e0b"
									>
										{{ result[2]?.result }}
									</span>
								</div>
								<div
									v-if="result[3]?.count > 0"
									class="flex flex-nowrap items-center mb-4 justify-center"
								>
									<div
										class="text-sm font-semibold text-neutral-500 w-14 blue"
									>
										{{ result[3]?.count }}
										M.T
									</div>
									<span
										class="flex items-center justify-center px-3 py-0.5 rounded-full text-sm text-white font-semibold w-32 whitespace-nowrap shadow-input"
										style="background: #f87171"
									>
										{{ result[3]?.result }}
									</span>
								</div>
								<div
									v-if="
										result[4]?.count > 0 ||
										result[5]?.count > 0 ||
										result[6]?.count > 0
									"
									class="flex flex-nowrap items-center mb-4 justify-center"
								>
									<div
										class="text-sm font-semibold text-neutral-500 w-14 blue"
									>
										{{
											result[4]?.count +
											result[5]?.count +
											result[6]?.count
										}}
										M.T
									</div>
									<span
										class="flex items-center justify-center px-3 py-0.5 rounded-full text-sm text-white font-semibold w-32 whitespace-nowrap shadow-input"
										style="background: #9ca3af"
									>
										X
									</span>
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="
							radarData.length && radarData[0]?.data.length >= 3
						"
						class="xl-down:mt-6 w-2/3 xl-down:w-full flex flex-col min-h-0 min-w-0"
					>
						<div
							class="bg-white shadow-sm overflow-hidden rounded-2xl pb-5 flex flex-col flex-1 min-h-0"
						>
							<div
								class="font-semibold text-neutral-500 p-6 shrink-0"
							>
								Biểu đồ mối tương quan giữa kết quả các lĩnh vực
							</div>
							<div
								class="flex flex-1 flex-col min-h-0 p-6 border-t border-orange-50 md-down:px-0 overflow-x-auto w-full"
							>
								<apexchart
									:options="radarChartOptions"
									:series="radarData"
									height="400"
									type="radar"
								></apexchart>
								<div
									class="py-4 flex flex-wrap gap-6 justify-center items-center"
								>
									<div
										v-for="(c, index) in categories"
										:key="c"
										class="flex items-center flex-nowrap gap-2"
									>
										<div
											class="font-bold text-lf text-neutral-700"
										>
											{{ index + 1 }}: {{ c }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="relative mt-6">
					<div
						aria-hidden="true"
						class="absolute inset-0 flex items-center"
					>
						<div class="w-full border-t border-neutral-300" />
					</div>
					<div class="relative flex items-center justify-center">
						<div
							class="px-2.5 py-1 bg-body text-neutral-600 font-semibold"
						>
							Kết quả mục tiêu đã học
						</div>
					</div>
				</div>
				<div
					v-for="(s, index) in skills"
					:key="index"
					class="mt-10 block shadow-sm"
				>
					<div class="flex items-center justify-between mb-4">
						<div class="flex items-center">
							<div class="font-semibold text-neutral-700">
								{{ index + 1 }}. {{ s.skill?.name }}
							</div>
							<div class="flex items-center gap-2" v-if="s.age">
								<div>:</div>
								<div class="font-semibold text-green-500">
									{{ s.age }} {{ s.unit }}
								</div>
							</div>
						</div>
						<div v-if="useAi && !assessment?.sent_at">
							<div v-if="editGoal && goalIndex === index">
								<button
									class="flex items-center gap-2 luca-button"
									@click="save"
								>
									<img
										class="w-4 h-4"
										src="@/assets/images/icons/save.png"
										alt=""
									/>
									<div>Lưu chỉnh sửa</div>
								</button>
							</div>
							<div
								v-else
								class="flex items-center gap-2 cursor-pointer"
								@click="edit(index)"
							>
								<img
									class="w-4 h-4"
									src="@/assets/images/icons/edit-fill.png"
									alt=""
								/>
								<div class="text-yellow-700 font-semibold">
									Chỉnh sửa
								</div>
							</div>
						</div>
					</div>
					<div v-if="editGoal && goalIndex === index">
						<div
							class="text-xs font-semibold uppercase mb-2 text-gray-400"
						>
							Tuổi phát triẻn
						</div>
						<div class="mb-4">
							<div class="flex items-center gap-2">
								<div class="input-group" style="width: 100px">
									<input type="number" v-model="s.age" />
								</div>
								<Multiselect
									style="width: 200px"
									:options="unitType"
									v-model="s.unit"
									:allow-empty="false"
									placeholder="Chọn loại tuổi"
									deselect-label=""
									selectLabel=""
								>
								</Multiselect>
							</div>
						</div>
					</div>
					<div
						class="shadow-sm sm:rounded-2xl overflow-hidden md-down:hidden"
					>
						<div class="__record__table overflow-x-auto scroll-bar">
							<div
								class="overflow-hidden sm:rounded-t-2xl w-fit min-w-full"
							>
								<table
									class="min-w-full divide-y text-neutral-200"
								>
									<thead class="bg-neutral-100 h-16">
										<tr>
											<th
												class="px-4 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap w-16"
												scope="col"
											>
												STT
											</th>
											<th
												class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
												scope="col"
											>
												Mục Tiêu
											</th>
											<th
												class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
												scope="col"
												style="width: 80px"
											>
												Kết quả
											</th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(i, gIndex) in s.goals"
											:key="gIndex"
											:class="[
												gIndex % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50',
												i.show && goalIndex !== index
													? 'opacity-30'
													: '',
											]"
											class="cursor-pointer text-neutral-700 hover:bg-orange-50"
											@click="
												openGoalDetail(
													i.goal_id || i.id
												)
											"
										>
											<td
												class="p-4 whitespace-nowrap text-neutral-700 text-center"
											>
												{{ gIndex + 1 }}
											</td>
											<td
												class="px-6 py-4 whitespace-nowrap text-neutral-700"
											>
												<div
													class="flex items-center gap-2"
												>
													<div
														class="whitespace-normal"
														v-html="
															i.name ||
															i.goal_name
														"
													></div>
													<!-- <TooltipGoalDetail
												:goal-id="i.goal_id || i.id"
												:student-id="route.params.id"
											/> -->
												</div>
												<div
													class="flex gap-2 flex-wrap"
													style="max-width: 360px"
												>
													<template
														v-if="
															i?.assistance_levels
														"
													>
														<div
															v-for="ass in i?.assistance_levels"
															:key="ass"
															class="flex gap-2"
														>
															<div
																class="mt-1 py-0.5 px-2.5 rounded-full bg-pink-100 whitespace-nowrap text-neutral-700 h-fit w-fit font-semibold shadow-input"
																style="
																	font-size: 10px;
																"
															>
																{{ ass }}
															</div>
														</div>
													</template>
													<div
														class="mt-1 py-0.5 px-2.5 rounded-full bg-yellow-tag text-neutral-700 h-fit w-fit font-semibold shadow-input whitespace-nowrap"
														style="font-size: 10px"
														v-if="i?.age"
													>
														{{ i?.age }}
													</div>
												</div>
												<div
													class="flex items-center gap-2 mt-2 text-neutral-400 text-xs font-semibold"
												>
													<div v-if="i?.has_media">
														<img
															alt=""
															src="@/assets/images/icons/has_media.png"
														/>
													</div>
													<div
														v-if="
															i.number_of_assessment >
															0
														"
													>
														ĐÃ HỌC
														{{
															i.number_of_assessment
														}}
														NGÀY
													</div>
													<div v-if="i.start_date">
														|
													</div>
													<div v-if="i.start_date">
														{{
															$filters.formatDate(
																i.start_date
															)
														}}
													</div>
													<div v-if="i.completed_at">
														-
													</div>
													<div v-if="i.completed_at">
														{{
															$filters.formatDate(
																i.completed_at
															)
														}}
													</div>
													<div v-if="i?.completed_at">
														<img
															alt=""
															src="@/assets/images/icons/has_taught.png"
														/>
													</div>
												</div>
												<div
													v-if="
														i.parent
															?.sub_goal_count > 0
													"
													class="goal-block flex gap-3 mt-2"
												>
													<img
														class="w-3 h-3 mt-1"
														src="@/assets/images/icons/goal-arrow.png"
														alt=""
													/>
													<div>
														<div
															class="text-neutral-700 whitespace-normal"
															v-html="
																i.parent?.name
															"
														></div>
														<div
															class="text-neutral-400 text-xs font-semibold"
														>
															{{
																i.parent
																	?.sub_goal_count
															}}
															MỤC TIÊU
														</div>
													</div>
												</div>
											</td>
											<td
												class="px-6 py-4 whitespace-nowrap text-neutral-700"
											>
												<div
													v-if="
														i?.student_assessment_form_result
													"
												>
													<div
														:style="{
															background:
																$filters.tagResult(
																	String(
																		i
																			?.student_assessment_form_result
																			?.complete_percent
																	)
																)?.background,
															color: $filters.tagResult(
																String(
																	i
																		?.student_assessment_form_result
																		?.complete_percent
																)
															)?.color,
														}"
														class="py-0.5 px-2.5 rounded-full text-neutral-700 h-fit w-fit font-semibold text-sm shadow-input"
													>
														{{
															i
																?.student_assessment_form_result
																?.display_complete_percent ||
															0
														}}
													</div>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped>
.block {
	border-radius: 8px;
	padding: 24px;
	background: #ffffff;
	border: none !important;
}
.percent {
	height: 24px;
	border-radius: 0 99px 99px 0;
	background: #f9a8d4;
}
.student-age {
	border: 3px dashed #86a8d0;
}
.r-age {
	background: #6390c3;
}
.d-age {
	background: #f9a8d4;
}
.student-age::before,
.student-age::after {
	content: '';
	position: absolute;
	left: -7.5px;
	width: 15px;
	height: 15px;
	background-color: #6390c3;
	border-radius: 50%;
}

.student-age::before {
	top: -10px;
}

.student-age::after {
	bottom: -10px;
}
.menu-action {
	z-index: 100;
	right: 0px;
	border-radius: 6px;
	border: 1px solid #f9e3b7;
	background: #fff;
	width: 224px;
	box-shadow: 0px 10px 16px 0px rgba(20, 37, 63, 0.06),
		0px 0px 1px 0px rgba(12, 26, 75, 0.1);
}
.bot-190 {
	bottom: -190px;
}
.bot-15 {
	bottom: -150px;
}
.bot-20 {
	bottom: -80px !important;
}
</style>
